import { render } from "./ImageCarousel.vue?vue&type=template&id=824bae6a&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=824bae6a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824bae6a"]])

export default __exports__